import {useCallback, useState} from 'react';
import {Button} from '~library/atoms/Button';
import {Header} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/Header/Header';
import {Step} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/Step';
import {Payload} from '~/ViewInvitation/common/RSVPModalVariantAB/types';
import {JoinTheClub} from './components/JoinTheClub/JoinTheClub';
import {PartyTips} from './components/PartyTips';

import './ChuckECheese.sass';

export type CecPreferences = Pick<Payload, 'vendor_optin' | 'optin'>;

type ChuckECheeseProps = {
  onCloseClick: () => void;
  onCtaClick: (value: CecPreferences) => void;
};

const VENDOR = 'cec';

export const ChuckECheese = ({onCtaClick, onCloseClick}: ChuckECheeseProps) => {
  const [vendorsOptin, setVendorsOptin] = useState<string[]>([VENDOR]);
  const [hasOptin, setHasOptin] = useState(true);

  const onJoinTheClubHandler = useCallback(
    (value: boolean) => {
      if (!value) {
        setVendorsOptin(vendorsOptin.filter((vendor: string) => vendor !== VENDOR));
      } else {
        setVendorsOptin([...vendorsOptin, VENDOR]);
      }
    },
    [vendorsOptin]
  );

  const onCtaClickHandler = useCallback(
    async () =>
      onCtaClick({
        vendor_optin: vendorsOptin,
        optin: hasOptin,
      }),
    [hasOptin, onCtaClick, vendorsOptin]
  );

  return (
    <Step
      header={<Header onClose={onCloseClick} title="Sign up for more fun:" />}
      footer={
        <Button
          variant="primary"
          size="large"
          data-qa-id="cec-save-preferences"
          onClick={onCtaClickHandler}
          className="rsvp-step__footer__cta"
        >
          Save preferences
        </Button>
      }
    >
      <div className="rsvp__chuck-e-cheese__content-wrapper">
        <JoinTheClub onChange={onJoinTheClubHandler} isActive={vendorsOptin.includes(VENDOR)} />
        <PartyTips onChange={setHasOptin} isActive={hasOptin} />
      </div>
    </Step>
  );
};
